<template>
  <div v-show="!hideCurrentModal" class="modal twoFaPhoneModal">
    <div class="modal--backdrop" @click="dismiss()"></div>
    <div class="modal--content">
      <div class="modal--content-body">
        <figure class="twoFaImg">
          <img src="@/assets/images/twoFactor.svg" alt="" />
        </figure>
        <div class="HeadingtextinfoDv">
          <h2>{{ $t("setting.twoFactorAuth.title") }}</h2>
          <p>
            {{ $t("setting.twoFactorAuth.description") }}
          </p>
        </div>
        <div class="CustomCheckboxWrapper deleteDesclaimer">
          <div class="checkbox_wrapper widget">
            <input :id="`info${isSelectTwoFaType.isPhone}`" type="checkbox" class="custom-checkbox"
              :value="isSelectTwoFaType.isPhone" :checked="isSelectTwoFaType.isPhone" @change="changeStatus()" />
          </div>
          <div class="checkboxLableDv">
            {{ $t("setting.twoFactorAuth.phone") }}
          </div>
        </div>
        <div class="inputWithLabelDv">
          <vue-tel-input :class="{ numbErrorBorder: showErrorMessageNumberExist }" @validate="validatePhoneNumber"
            :inputOptions="options" @input="CheckingVerificationPhoneNumber(userInfo.phoneNumber)"
            class="WinningTradeinputDv" v-model="userInfo.phoneNumber" :validCharactersOnly="true" mode="international">
            <template v-if="showFirbaseVerification" #icon-right>
              <div class="verifyInfoChangeDv" @click="openPhoneNumberVerificationPopup()"
                v-if="!userInfo.isPhoneVerified">
                <p>{{ $t("setting.common.verify") }}</p>
              </div>
              <div class="verifyInfoChangeDv" v-else-if="userInfo.phoneNumber?.length">
                <p>{{ $t("setting.common.verified") }}</p>
              </div>
            </template>
          </vue-tel-input>
          <span class="numbError" v-if="showErrorMessageNumberExist">{{
            $t("setting.twoFactorAuth.numberExists")
          }}</span>
        </div>
        <div class="btninfoDv">
          <button class="btn btn--primary" v-if="isLoading">
            <div class="loader"></div>
          </button>
          <button class="btn btn--primary" :class="{ disabled: btnDisabled }" @click="submitPhoneNumber()" v-else>
            {{ $t("common.actions.submit") }}
          </button>
          <button class="btn btn--outline" @click="dismiss()">
            {{ $t("common.actions.cancel") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import IconComponent from "@/components/IconComponent.vue";
import { VerifyFirebaseToken } from "@/helpers/models/verify_firebase";
import firebaseService from "@/services/firebase.service";
import httpService from "@/services/http.service";
import storageService from "@/services/storage.service";
import utilService from "@/services/util.service";
import { getAuth, RecaptchaVerifier, User } from "firebase/auth";
import { popModal, promptModal } from "jenesius-vue-modal";
import { defineComponent, onMounted, ref, computed } from "vue";
import { TYPE } from "vue-toastification";
import VOtpInput from "vue3-otp-input";
import PhoneNumberVerificationPopup from "./PhoneNumberVerificationPopup.vue";
import { VueTelInput } from "vue-tel-input";
import "vue-tel-input/vue-tel-input.css";
import { twoFactAuthComposable } from "../../twoFactorAuth-composables";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "Testing",
  props: {
    userData: Object,
  },
  components: {
    VOtpInput,
    IconComponent,
    PhoneNumberVerificationPopup,
    VueTelInput,
  },
  setup(props) {
    const { t } = useI18n();
    const options = {
      showDialCode: true,
      required: true,
    };
    const showFirbaseVerification = ref<Boolean>(false);
    const showErrorMessageNumberExist = ref<Boolean>(false);
    const btnDisabled = computed(() => {
      return userInfo.value.phoneNumber?.length < 6;
    });

    const { verifyTwoFaPhoneNumber, authData, loadTwoFaAuth } =
      twoFactAuthComposable();
    const isSelectTwoFaType = ref<any>({
      isPhone: true,
      isEMail: false,
    });
    const isLoading = ref<boolean>(false);
    const timeout = ref<number>(-1);
    const dismiss = () => popModal();
    const user = ref<any>();
    const code = ref<string>("");
    const userInfo = ref<any>({
      phoneNumber: "",
      isPhoneVerified: false,
    });

    const isFormValid = computed<string>(() => {
      if (userInfo.value.phoneNumber && !userInfo.value.isPhoneVerified) {
        return t("setting.twoFactorAuth.errors.verifyPhoneNumber");
      } else if (!userInfo.value.phoneNumber) {
        return t("setting.twoFactorAuth.errors.fieldBlank");
      }

      return "";
    });

    onMounted(async () => {
      user.value = storageService.getUser();
      await loadTwoFaAuth();
    });

    const changeStatus = () => {
      isSelectTwoFaType.value.isPhone = !isSelectTwoFaType.value.isPhone;
    };

    const submitPhoneNumber = async () => {
      isLoading.value = true;
      if (isFormValid.value) {
        isLoading.value = false;
        utilService.showToast(isFormValid.value, TYPE.ERROR);
        return;
      }
      let obj = {
        type: "phone",
        value: userInfo.value.phoneNumber,
      };
      await httpService
        .twoFactorAuthenticationPost(obj)
        .then(async (response) => {
          if (response.isSuccess) {
            isLoading.value = false;
            utilService.showToast(response.message, TYPE.SUCCESS);
            verifyTwoFaPhoneNumber(response.data);
          } else {
            isLoading.value = false;
          }
        })
        .catch((e) => {
          isLoading.value = false;
        });
    };
    const hideCurrentModal = ref<Boolean>(false);
    const openPhoneNumberVerificationPopup = async () => {
      if (userInfo.value && userInfo.value.phoneNumber) {
        hideCurrentModal.value = true;
        var modal: any = await promptModal(PhoneNumberVerificationPopup, {
          userData: userInfo.value,
          is2FaAuth: true,
        });
        if (modal != null) {
          if (modal == "close") {
            hideCurrentModal.value = false;
          } else {
            userInfo.value.phoneNumber = modal.userData!.phoneNumber;
            userInfo.value.isPhoneVerified = modal.userData.isPhoneVerified;
            user.value.phone = userInfo.value.phoneNumber;
            user.value.isPhoneVerified = userInfo.value.isPhoneVerified;
            hideCurrentModal.value = false;
          }
        }
      } else {
        utilService.showToast(t("setting.toast.verifyPhone"), TYPE.ERROR);
      }
    };

    const CheckingVerificationPhoneNumber = async (data: any) => {
      if (data === user.value.phone) {
        userInfo.value.isPhoneVerified = true;
      } else {
        userInfo.value.isPhoneVerified = false;
      }
    };
    const checkPhoneNumberExists = (phoneNumber: any) => {
      return authData.value.some((auth: any) => {
        const normalizedArrayPhoneNumber = auth.email.replace(/\s/g, "");
        return normalizedArrayPhoneNumber === phoneNumber;
      });
    };
    const validatePhoneNumber = async (data: any) => {
      showErrorMessageNumberExist.value = false;
      if (data.valid) {
        const isValid = checkPhoneNumberExists(data.number);
        if (isValid) {
          showErrorMessageNumberExist.value = true;
        } else {
          showFirbaseVerification.value = true;
        }
      }
    };

    return {
      code,
      dismiss,
      userInfo,
      isLoading,
      user,
      timeout,
      CheckingVerificationPhoneNumber,
      openPhoneNumberVerificationPopup,
      submitPhoneNumber,
      isFormValid,
      isSelectTwoFaType,
      changeStatus,
      options,
      validatePhoneNumber,
      showFirbaseVerification,
      showErrorMessageNumberExist,
      btnDisabled,
      hideCurrentModal,
    };
  },
});
</script>
  <style lang="scss" scoped>
.numbError {
  color: var(--red2);
  font-size: var(--font-2xs);
  transition: 0.4s;
}
.numbErrorBorder {
  border: 1px solid var(--red2);
}

.twoFaPhoneModal {
  .modal--content {
    height: 630px;
    max-height: 96vh;
    .modal--content-body {
      overflow: auto;
      padding: 50px;
      @include scrollbar();
      overflow: auto;
      
      .twoFaImg {
        display: flex;
        justify-content: center;
        padding-top: 0;
        padding-bottom: 50px;
        img {
          width: 300px;
        }
      }
      .HeadingtextinfoDv {
        margin-bottom: 20px;
        h2 {
          font-size: var(--font-2xl);
          color: var(--text-color);
          text-align: center;
          margin: 0px;
          padding: 0px;
          line-height: 1;
          letter-spacing: 0px;
          font-weight: 500;
        }
        p {
          font-size: var(--font-2sm);
          color: var(--text-color);
          text-align: center;
          margin: 15px 0px 0px;
          padding: 0px;
          line-height: 1.6;
          letter-spacing: 0px;
          font-weight: 400;
          opacity: 0.7;
        }
      }
      .inputWithLabelDv {
        margin: 0px;
        position: relative;
        z-index: 2;

        .verifyInfoChangeDv {
          background: var(--base-light);
          color: var(--text-color);
          height: 35px;
          width: max-content;
          padding: 0px 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          border-radius: 4px;
          max-width: 65px;
          min-width: 55px;

          p {
            line-height: 1;
            font-size: var(--font-xs);
            margin: 0px;
            padding: 0px;
            letter-spacing: 0px;
            font-weight: 400;
          }
        }
      }
      .resendDv {
        p {
          font-size: var(--font-sm);
          color: var(--text-color);
          opacity: 0.3;
          cursor: pointer;
          text-align: center;
          margin: 0px 0px 20px;
          padding: 0px;
          letter-spacing: 0px;
          line-height: 1;
        }
      }
      .btninfoDv {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 20px;
        flex-direction: column;
        margin-top: 40px;
        .btn {
          font-size: var(--font-2sm);
          width: 100%;
          margin: 0px;
        }
      }
      .code-resend {
        margin: 0px 0px 20px;
        p {
          margin: 0;
          text-align: center;
          font-size: var(--font-xs);
          font-weight: 400;
          span {
            color: var(--secondary-color);
          }
        }
        a {
          text-align: center;
          margin: 0 auto;
          display: block;
          margin-top: 20px;
          color: var(--text-color);
          cursor: pointer;
          font-size: var(--font-xs);
          font-weight: 500;
          &.disabled {
            opacity: 0.5;
            pointer-events: none;
            cursor: default;
          }
        }
      }
    }
  }
}
</style>
  
